<template>
  <div :class="['detail-css mr-2', typeClassName(type)]">
    {{ typeName(type) }}
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
    },
  },
  methods: {
    typeName(type) {
      const classMap = {
        BOX: "Box",
        POLYGON: "Polygon",
        GROUP_POINT: "Point(Group)",
        SINGLE_POINT: "Point(Single)",
        ATTRIBUTE: "Attribute",
        INSPECT_COMPLETE: "File",
      };

      return classMap[type] || "";
    },
    typeClassName(type) {
      const classMap = {
        BOX: "box-color",
        POLYGON: "polygon-color",
        GROUP_POINT: "point-group-color",
        SINGLE_POINT: "point-single-color",
        ATTRIBUTE: "attribute-color",
        INSPECT_COMPLETE: "file-color",
      };

      return classMap[type] || "";
    },
  },
};
</script>

<style lang="scss" scoped>
.detail-css {
  width: 88px;
  height: 21px;
  text-align: left;
  padding-left: 8px;
  border-radius: 5px;
  color: black;
  font-size: 13px;
  font-weight: 500;
}
</style>
